
import state from './moduleClientFieldsManagementState'
import mutations from './moduleClientFieldsManagementMutations'
import actions from './moduleClientFieldsManagementActions'
import getters from './moduleClientFieldsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

